import { useSyncExternalStore } from 'react';

export interface SessionUser {
  id: string;
  email: string;
  platformRole: 'user' | 'admin';
}

export interface SessionOrg {
  id: string;
  slug: string;
  role: 'owner' | 'admin' | 'member';
}

export interface Session {
  user: SessionUser;
  activeOrg: SessionOrg;
  accessToken: string;
  accessTokenExpiresAt: number;
}

type Listener = () => void;

let currentSession: Session | null = null;
const listeners = new Set<Listener>();

function notify(): void {
  for (const l of listeners) l();
}

export function getSession(): Session | null {
  return currentSession;
}

export function setSession(session: Session | null): void {
  currentSession = session;
  notify();
}

export function updateAccessToken(accessToken: string, accessTokenExpiresAt: number): void {
  if (!currentSession) return;
  currentSession = { ...currentSession, accessToken, accessTokenExpiresAt };
  notify();
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useSession(): Session | null {
  return useSyncExternalStore(subscribe, getSession, getSession);
}
